import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const words = [
    "Independent Soul Universe",
    "Original Stories",
    "Recurring Voices",
    "Cut Warm To Tape",
  ];
  return (
    <section data-testid="marquee-section" className="relative border-y border-vt-gold/10 py-8 md:py-12">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-serif text-5xl italic leading-none md:text-7xl lg:text-8xl">
            <span className="vt-text-outline">{w}</span>
            <span className="text-vt-gold">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
